import React, { useState, useEffect } from 'react';
import './About.css';
import Card from "./Card";
import "./Card.css";

const images = [
    { src: "/1.jpg", alt: "Drone Training" },
    { src: "/2.jpg", alt: "Simulator Training" },
    { src: "/3.jpg", alt: "Hands-on Flying" },
  ];


const cardsData = [
    {
      image: "/1.jpg",
      alt: "Facility 1",
      title: "Drone Training",
      description: "Learn advanced drone operations in a modern lab.",
    },
    {
      image: "/2.jpg",
      alt: "Facility 2",
      title: "Simulator Training",
      description: "Practice in a realistic simulator environment.",
    },
    {
      image: "/3.jpg",
      alt: "Facility 3",
      title: "Hands-on Flying",
      description: "Get real flying experience with expert guidance.",
    },
  ];
const AboutUs = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [collaborators, setCollaborators] = useState([]);
     const [selectedImage, setSelectedImage] = useState(images[0].src);
     const [currentIndex, setCurrentIndex] = useState(0);



  // ✅ Fetch collaborators from backend
  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL+"/admin/images")
      .then((res) => res.json())
      .then((data) => {
        setCollaborators(data);
      })
      .catch((err) => console.error("Error fetching collaborators:", err));
  }, []);

  // Debugging image load
  // const handleImageError = (e, collaboratorName, imageSrc) => {
  //   console.error(`❌ Failed to load image for ${collaboratorName}:`, imageSrc);
  //   e.target.src = `https://via.placeholder.com/200x100/e2e8f0/64748b?text=${encodeURIComponent(collaboratorName)}`;
  // };

  // const handleImageLoad = (collaboratorName) => {
  //   console.log(`✅ Loaded image for: ${collaboratorName}`);
  // };

  // Scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleScroll = () => setShowScrollButton(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  },[]);

  // Update selected image whenever currentIndex changes
  useEffect(() => {
    setSelectedImage(images[currentIndex].src);
  }, [currentIndex]);

  return (
    <div className="about-us-container">
      {/* Particle background */}
      <div className="particles-background">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="particle" style={{
            '--x': `${Math.random() * 100}%`,
            '--y': `${Math.random() * 100}%`,
            '--size': `${Math.random() * 10 + 5}px`,
            '--duration': `${Math.random() * 20 + 10}s`,
            '--delay': `${Math.random() * 5}s`
          }} />
        ))}
      </div>

      {/* <section className="about-section">
      <div className="about-container">

        <div className="about-content">
          <div className="content-wrapper">
            <div className="section-header">
              <h1 className="AboutTitle">About Us</h1>
            </div>
            <div className="section-description">
              <p className="about-paragraph">
                Flytutor is pioneering the future of drone education,
                making advanced aerial technology
                accessible to everyone. Founded by aviation
                experts and tech innovators,
                we provide comprehensive training programs that combine
                cutting-edge knowledge with hands-on flight experience.
              </p>
            </div>


            <div className="image-only-cards">
              {images.map((img, index) => (
                <div
                  key={index}
                  className={`image-card ${selectedImage === img.src ? "active" : ""}`}
                  onClick={() => setSelectedImage(img.src)}
                >
                  <img src={img.src} alt={img.alt} />
                </div>
              ))}
            </div>
          </div>
        </div>


        <div className="about-image">
          <img src={selectedImage} alt="Selected" className="main-image" />
        </div>
      </div> */}
       <section className="about-section">
      <div className="about-container">
        {/* Left side content */}
        <div className="about-content">
          <div className="content-wrapper">
            <div classNameName="section-header">
              <h1 className="AboutTitle">About Us</h1>
            </div>
            <div className="section-description">
              <p className="about-paragraph">
                Flytutor is pioneering the future of drone education, making
                advanced aerial technology accessible to everyone. Founded by
                aviation experts and tech innovators, we provide comprehensive
                training programs that combine cutting-edge knowledge with
                hands-on flight experience.
              </p>
            </div>

            {/* Image Thumbnails */}
            <div className="image-only-cards">
              {images.map((img, index) => (
                <div
                  key={index}
                  className={`image-card ${
                    selectedImage === img.src ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedImage(img.src);
                    setCurrentIndex(index);
                  }}
                >
                  <img src={img.src} alt={img.alt} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right side large image */}
        <div className="about-image">
          <img src={selectedImage} alt="Selected" className="main-image" />
        </div>
      </div>


      {/* Features Grid */}
      <div className="features-grid">
        <div className="feature-card">
          <div className="feature-icon">🎯</div>
          <h3>Expert Training</h3>
          <p>Industry-leading curriculum designed by aviation professionals</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">🛡️</div>
          <h3>Safety First</h3>
          <p>Comprehensive safety protocols and best practices</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">🚀</div>
          <h3>Innovation</h3>
          <p>Cutting-edge technology and training methods</p>
        </div>
      </div>

      {/* Statistics Section */}
      <div className="stats-container">
        <div className="stat-item">
          <div className="stat-number">100+</div>
          <div className="stat-label">Students Trained</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">12</div>
          <div className="stat-label">Courses</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">100+</div>
          <div className="stat-label">Certificates Issued</div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="section-corner corner-top-left"></div>
      <div className="section-corner corner-top-right"></div>
      <div className="section-corner corner-bottom-left"></div>
      <div className="section-corner corner-bottom-right"></div>
      <div className="dots-pattern"></div>
      <div className="gradient-overlay"></div>
    </section>

      {/* After About section */}
      <div className="wave-pattern"></div>
      <div className="section-divider">
        <div className="section-divider-icon">↓</div>
      </div>
      <div className="floating-element floating-element-1"></div>
      <div className="floating-element floating-element-2"></div>

      {/* Who We Are Section */}
      <section className="who-we-are-section">
        <div className="section-header">
          <h2 className="AboutTitle">Who We Are</h2>
        </div>

        <div className="who-we-are-content">
          <div className="circular-container">
            <div className="orbit">
              <div className="planet">
                <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Team" className="team-image" />
              </div>
              {[...Array(6)].map((_, i) => (
                <div key={i} className="satellite" style={{
                  '--angle': `${i * 60}deg`,
                  '--distance': '120px',
                  '--size': `${40 + i * 5}px`,
                  '--duration': `${15 + i * 2}s`,
                  '--delay': `${i * 0.5}s`
                }}>
                  <div className="satellite-inner"></div>
                </div>
              ))}
            </div>
          </div>

          <div className="info-cards">
            <div className="info-card">
              <div className="card-icon">🚀</div>
              <h3>Innovation</h3>
              <p>At Flytutor, innovation drives everything we do.
                We integrate cutting-edge drone technology with immersive learning experiences,
                ensuring students gain real-world skills. Our forward-thinking approach keeps us ahead, shaping the future of drone training.
</p>
            </div>
            <div className="info-card">
              <div className="card-icon">🤝</div>
              <h3>Collaboration</h3>
              <p>Collaboration is where ideas take flight.
                 By uniting with industry leaders and visionary partners,
                  we open doors to limitless learning opportunities. Together,
                   we’re building a powerful network that shapes the future of drone technology.</p>
            </div>
            <div className="info-card">
              <div className="card-icon">💡</div>
              <h3>Creativity</h3>
              <p>Creativity is our lift-off. We blend imagination with technology to craft unique, engaging learning experiences. Every idea we spark fuels innovation and transforms the way drone training is delivered.
</p>
            </div>
          </div>
        </div>
        <div className="section-corner corner-top-left"></div>
        <div className="section-corner corner-top-right"></div>
        <div className="section-corner corner-bottom-left"></div>
        <div className="section-corner corner-bottom-right"></div>
        <div className="dots-pattern"></div>
        <div className="gradient-overlay"></div>
      </section>

      {/* After Who We Are section */}
      <div className="wave-pattern"></div>
      <div className="section-divider">
        <div className="section-divider-icon">↓</div>
      </div>
      <div className="floating-element floating-element-2"></div>
      <div className="floating-element floating-element-3"></div>

      {/* Our Highlights Section */}
      <section className="highlights-section">
        <div className="section-header">
          <h2 className="AboutTitle">Our Highlights</h2>

          <div className="highlight-points">
            <div className="point-card" style={{'--delay': '0s'}}>
              <div className="point-content">
                <h3>Excellence</h3>
                <p>DGCA-Authorized Remote Pilot Training Organization.
                    Excellence drives us, pushing every effort to deliver nothing but the best.
</p>
              </div>
            </div>
            <div className="point-card" style={{'--delay': '0.2s'}}>
              <div className="point-content">
                <h3>Innovation</h3>
                <p>Real-World Curriculum with Theory + Practical Modules.
                    Innovation propels us forward, turning bold ideas into transformative solutions.
</p>
              </div>
            </div>
            <div className="point-card" style={{'--delay': '0.4s'}}>
              <div className="point-content">
                <h3>Integrity</h3>
                <p>Focus on Safety,Compliance and Ariel Mission Planning.
                    Integrity is our compass, guiding every decision with honesty, transparency, and trust.
</p>
              </div>
            </div>
            <div className="point-card" style={{'--delay': '0.6s'}}>
              <div className="point-content">
                <h3>Collaboration</h3>
                <p>Industry Colloborations with Drone StartUps & Tech.
                    Collaboration sparks growth, bringing together minds and expertise to achieve greater heights.
</p>
              </div>
            </div>
            {/* Added two new containers */}
            <div className="point-card" style={{'--delay': '0.8s'}}>
              <div className="point-content">
                <h3>Expertise</h3>
                <p>Trained by Industry Experts with Years of Experience.
                    Expertise defines us, built on knowledge, skill, and unwavering dedication.
</p>
              </div>
            </div>
            <div className="point-card" style={{'--delay': '1.0s'}}>
              <div className="point-content">
                <h3>Technology</h3>
                <p>State-of-the-Art Equipment and Simulation Tools.
                    Technology empowers us, transforming learning into a smarter, future-ready experience.
</p>
              </div>
            </div>
          </div>
        </div>
        <div className="section-corner corner-top-left"></div>
        <div className="section-corner corner-top-right"></div>
        <div className="section-corner corner-bottom-left"></div>
        <div className="section-corner corner-bottom-right"></div>
        <div className="dots-pattern"></div>
        <div className="gradient-overlay"></div>
      </section>

      {/* After Highlights section */}
      <div className="wave-pattern"></div>
      <div className="section-divider">
        <div className="section-divider-icon">↓</div>
      </div>
      <div className="floating-element floating-element-1"></div>
      <div className="floating-element floating-element-3"></div>

      {/* Our Approval Section */}
      <section className="approval-section">
        <div className="section-header">
          <h2 className="AboutTitle">Approved by DGCA</h2>
        </div>

        <div className="approval-container">
          <div className="certificates-wrapper">
            <div className="certificate-card" style={{'--delay': '0s'}}>
              <div className="certificate-frame">
                <div className="certificate-seal">✓</div>
                <img
                  src="/images/approval/certificate1.jpeg"
                  alt="Certificate of Excellence"
                  className="certificate-image"
                />
                <div className="certificate-overlay">
                  <div className="overlay-content">
                    <h3>Certificate of Recognition</h3>
                    <p>Proudly presented as a Certificate of Recognition for outstanding dedication and achievement.
</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="certificate-card" style={{'--delay': '0.3s'}}>
              <div className="certificate-frame">
                <div className="certificate-seal">✓</div>
                <img
                  src="/images/approval/certificate2.jpeg"
                  alt="Quality Assurance Certificate"
                  className="certificate-image"
                />
                <div className="certificate-overlay">
                  <div className="overlay-content">
                    <h3>Certificate of Authorisation</h3>
                    <p>Officially granted as a Certificate of Authorisation, confirming approval and permission to operate.
</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="approval-text">
            <div className="approval-icon">🏅</div>
            <h3>Industry Recognized</h3>
            <p>Our commitment to excellence has been recognized by leading industry bodies. These certificates validate our dedication to quality, innovation, and customer satisfaction. They represent not just our achievements, but our promise to continue delivering exceptional value to all our stakeholders.</p>
          </div>
        </div>
        <div className="section-corner corner-top-left"></div>
        <div className="section-corner corner-top-right"></div>
        <div className="section-corner corner-bottom-left"></div>
        <div className="section-corner corner-bottom-right"></div>
        <div className="dots-pattern"></div>
        <div className="gradient-overlay"></div>
      </section>

      {/* After Approval section */}
      <div className="wave-pattern"></div>
      <div className="section-divider">
        <div className="section-divider-icon">↓</div>
      </div>
      <div className="floating-element floating-element-1"></div>
      <div className="floating-element floating-element-2"></div>

      {/* Why Choose FluyTutor Section */}
      <section className="fluytutor-section">
        <div className="section-header">
          <h2 className="AboutTitle">Why Choose Flytutor?</h2>
        </div>

        <div className="features-grid">
          <div className="feature-card" style={{'--delay': '0s'}}>
            <div className="feature-icon">🎯</div>
            <h3>Precision Training</h3>
            <p>Our drone training programs are designed with precision in mind, ensuring you master every control and technique with expert guidance.</p>
          </div>

          <div className="feature-card" style={{'--delay': '0.2s'}}>
            <div className="feature-icon">🛡️</div>
            <h3>Safety First</h3>
            <p>We prioritize safety above all else, teaching you the best practices and regulations to operate drones responsibly and confidently.</p>
          </div>

          <div className="feature-card" style={{'--delay': '0.4s'}}>
            <div className="feature-icon">🚁</div>
            <h3>Advanced Fleet</h3>
            <p>Train with the latest drone models and technology, giving you hands-on experience with cutting-edge equipment.</p>
          </div>

          <div className="feature-card" style={{'--delay': '0.6s'}}>
            <div className="feature-icon">📊</div>
            <h3>Data Analytics</h3>
            <p>Learn to collect, analyze, and interpret drone data for various applications, from mapping to inspection.</p>
          </div>

          <div className="feature-card" style={{'--delay': '0.8s'}}>
            <div className="feature-icon">🌐</div>
            <h3>Industry Connections</h3>
            <p>Our network of industry partners provides opportunities for internships, job placements, and real-world projects.</p>
          </div>

          <div className="feature-card" style={{'--delay': '1.0s'}}>
            <div className="feature-icon">🏆</div>
            <h3>Quick Certification Process</h3>
            <p>Our courses prepare you for industry-recognized certifications, boosting your credibility and career prospects.</p>
          </div>
        </div>
        <div className="section-corner corner-top-left"></div>
        <div className="section-corner corner-top-right"></div>
        <div className="section-corner corner-bottom-left"></div>
        <div className="section-corner corner-bottom-right"></div>
        <div className="dots-pattern"></div>
        <div className="gradient-overlay"></div>
      </section>

      <div className="wave-pattern"></div>
      <div className="section-divider">
        <div className="section-divider-icon">↓</div>
      </div>
      <section className="facilities-section">
        <div className="section-header">
          <h2 className="AboutTitle">Facilities</h2>
        </div>

        <div className="about-page">
          <p>
            Welcome to our training center! We provide High-class facilities
            and expert guidance for drone technology.
          </p>

          {/* Cards Section */}
          <div className="cards-wrapper">
            {cardsData.map((card, index) => (
              <Card
                key={index}
                image={card.image}
                alt={card.alt}
                title={card.title}
                description={card.description}
              />
            ))}
          </div>
        </div>


<div className="wave-pattern"></div>
<div className="collaboration-slider">
  <h2 className="collaboration-heading">Our Collaborations</h2>

  <div className="slider-track">
    {[...collaborators, ...collaborators].map((collaborator, index) => (
      <div key={index} className="collaboration-logo">
        <div className="logo-container">
          <img
            src={process.env.REACT_APP_API_URL+`${collaborator.url}`}
            alt={collaborator.filename || "Partner Logo"}
          />
        </div>
      </div>
    ))}
  </div>
</div>



        <div className="section-corner corner-top-left"></div>
        <div className="section-corner corner-top-right"></div>
        <div className="section-corner corner-bottom-left"></div>
        <div className="section-corner corner-bottom-right"></div>
        <div className="dots-pattern"></div>
        <div className="gradient-overlay"></div>

        <div className="cta-container">
          <div className="cta-text">
            <h3>Ready to Take Flight?</h3>
            <p>Join hundreds of successful drone pilots who started their journey with FluyTutor.</p>
          </div>
        </div>
      </section>

      {/* Floating Scroll to Top Button */}
      <div className={`floating-button ${showScrollButton ? 'visible' : ''}`} onClick={scrollToTop}>
        ↑
      </div>

    </div>
  );
};

export default AboutUs;




